import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { InMemoryCacheService, PermissionsService, UtilsService } from '../common';
import { OrganizationSettingsService } from '../pages/organization-settings/services/organization-settings.service';
import { CommonModule, Location } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AvatarModule } from 'primeng/avatar';
import { StyleClassModule } from 'primeng/styleclass';
import { RippleModule } from 'primeng/ripple';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ButtonModule,
        InputTextModule,
        AvatarModule,
        StyleClassModule,
        RippleModule,
        DropdownModule,
        TooltipModule,
        AppBreadcrumbComponent,
        AppSidebarComponent
    ],
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent implements OnInit {

    private permissions = inject(PermissionsService);

    @ViewChild('menubutton') menuButton!: ElementRef;
    @ViewChild('searchinput') searchInput!: ElementRef;
    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;
    searchActive: boolean = false;

    public canAccessBilling: boolean = false;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef,
        private cache: InMemoryCacheService,
        private location: Location,
        private organizationSettingsService: OrganizationSettingsService,
        private utils: UtilsService
    ) {
    }

    async ngOnInit() {
        // If no organizations are loaded, load them and set the current org.
        if(this.organizations.length === 0) {
            setTimeout(() => {
                this.utils.logger.info('Topbar ngOnInit: Loading organizations and setting current org');
                this.organizationSettingsService.loadOrganizationsAndSetCurrent();
            }, 500); // Delay to ensure services are initialized
        }

        this.canAccessBilling = await this.permissions.canAsync('Org.Billing.Access');
    }

    // get showOrgDropdown() {
    //     // return (this.organizationSettingsService.showOrgDropdown()); // Show only if the user navigate to org settings;
    //     // return (this.organizations.length > 1); // Show if user has more than 1 orgs
    // }

    get organizations() {
        return this.organizationSettingsService.organizations();
    }

    get currentSelectedOrg() {
        return this.organizationSettingsService.currentOrg();
    }

    onOrganizationChange(event: any) {
        if (event?.value) {
            this.utils.logger.info('Organization changed to:', event.value);
            this.organizationSettingsService.setCurrentOrg(event.value);
        }
        else{
            this.utils.logger.warn('Organization change event triggered but no value found:', event);
        }
    }

    activateSearch() {
        this.searchActive = true;
        setTimeout(() => {
            this.searchInput.nativeElement.focus();
        }, 100);
    }

    deactivateSearch() {
        this.searchActive = false;
    }
    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

    onSidebarButtonClick() {
        this.layoutService.showSidebar();
    }

    public onLogoutClicked() {
        this.cache.logout();
    }

    get isAccountFlow() {
        return this.location.path().split('?')[0].includes('account');
    }

    get avatarLabel() {
        return this.cache?.user?.firstName?.charAt(0).toUpperCase();
    }
}
